import { TWS_API_URL } from '../../environment/apis.config'
import { Payload } from './MissionCASTSlice'
import { timeouts } from '../../services/RequestTimeouts'
import { getAccessToken } from '../../utils/auth.util'

const fetchMissionCASTData = (payload: Payload, profileLabel: string = "default"): Promise<string | any> => {

  // const controller = new AbortController()
  // const signal = controller.signal
  const controller = payload.controller
  const signal = payload.signal
  
  //check if missioncast call is cancelled due to timeout or due to routecast selection
  let isTimeOutError = false
  return new Promise(async (resolve, reject) => {
    // store.dispatch(showApiLoading())
    const timeoutId = setTimeout(() => {
      controller.abort()
      isTimeOutError = true
      clearTimeout(timeoutId)
      // reject(new Error('Request Timeout'))
      // store.dispatch(hideApiLoading())
    }, timeouts.missionCAST)
    const token = await getAccessToken();
    fetch(`${TWS_API_URL}/missioncast`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        waypoints: [payload],
        subset: [
          'Pressure',
          'Ceiling',
          'DewpointTemperature',
          'Temperature',
          'Visibility',
          'WindDirection',
          'WindSpeed',
          'Weather',
          'PrecipitationPotentialIndex',
          'WindGust',
        ],
        forecastRange: 48,
        format: 'JSON',
        thresholds: {},
        profile: profileLabel || "default"
      }),
      signal,
    })
    .then((response) => {
      clearTimeout(timeoutId);
      if (response.status === 200) {
        resolve(response.json());
      } else {
        // Reject the promise with a custom error for non-200 responses
        reject({
          status: 400,
          message: "Something went wrong in missioncast. Please Try again",
        });
      }
    })
    .catch((err) => {
      clearTimeout(timeoutId)
      if (err.name === 'AbortError' && isTimeOutError) {
        reject(new Error('Request timed out. Please try again.'))
      } else if (!isTimeOutError) {
        reject(new Error('RouteCAST and MissionCAST cannot be used at the same time.'))
      }
      reject(err)
    })
  })
}

export default fetchMissionCASTData
